import { Component, OnInit } from '@angular/core';

import { AppData } from 'src/app/services/appdata.service';
import { API } from 'src/app/services/api.service';
import { Global } from 'src/app/services/global.service';
import { alertService } from 'src/app/services/alert-service.service';
import { ValidationService } from 'src/app/services/validation.service';


@Component({
  selector: 'app-subscription-discount',
  templateUrl: './subscription-discount.component.html',
  styleUrls: ['./subscription-discount.component.css']
})
export class SubscriptionDiscountComponent implements OnInit {
  regex: any = this.validator.regex;

  loader: boolean = false;
  valid_inputs: boolean = false;
  username: any = '';
  count: any = null;
  months: any = null;
  subscription_value: any = "Arc essentials";
  subscription_type: any = "arc_essentials"
  leed_id: any = null;

  changeSubscriptionType(type: any, val: any) {
    this.subscription_type = type;
    this.subscription_value = val;
    this.checkInputs();
  };

  validateEmail(email: any) {
    if (this.regex["email"].test(email)) {
      return true;
    }
    else {
      return false;
    }
  };

  validateLEEDId(leed_id: any) {
    if (this.regex["PrevCertProdId"].test(leed_id)) {
      return true;
    }
    else {
      return false;
    }
  };

  validateNumber(val: any) {
    if (this.regex["time_spent_by_riders"].test(val)) {
      return true;
    }
    else {
      return false;
    }
  };

  checkInputs() {
    if (this.subscription_type == "arc_essentials") {
      if (this.validateEmail(this.username) && this.validateNumber(this.count) && this.validateNumber(this.months)) {
        this.valid_inputs = true;
      }
      else {
        this.valid_inputs = false;
      }
    }
    else {
      if (this.validateLEEDId(this.leed_id) && this.validateNumber(this.months)) {
        this.valid_inputs = true;
      }
      else {
        this.valid_inputs = false;
      }
    }
  };

  saveStatus() {
    this.loader = true;
    var payload: any =
    {
      "object": this.leed_id,
      "months": parseInt(this.months),
    }

    if (this.subscription_type == "arc_essentials") {
      payload = {
        "object": this.username,
        "months": parseInt(this.months),
        "count": parseInt(this.count)
      }
    }

    this.api.post('/subscriptions/discount/', payload ).subscribe(
      data => {
        this.alertService.alert('success', 'Added discount to user email', 5);
        this.loader = false;
      }, error => {
        this.loader = false;
        this.alertService.alert('error', error['data']['detail'], 5);
      }
    );
  }

  constructor(
    public global: Global,
    private api: API,
    public appData: AppData,
    private alertService: alertService,
    private validator: ValidationService
  ) { }

  ngOnInit(): void {
  }

}
